import React from "react";
import DateRange from "../data-types/date-range";
import Location from "../data-types/location";
import Address from "../data-types/address";
import Vehicle from "../data-types/vehicle";
import Name from "../data-types/name";
import Text from "../data-types/text";
import Email from "../data-types/email";
import Date from "../data-types/date";
import Numeric from "../data-types/numeric";
import Currency from "../data-types/currency";
import Select from "../data-types/select";
import Format from "../data-types/format";
import OptionInput from "../data-types/optional-collection";
import Header from "../data-types/header";
import Options from "../data-types/options";
import Collection from "../data-types/collection";
import { deepEqual } from "../../utils/object";
import { RichTextLabel } from "../rich-text";

class QuestionItem extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            data: props.data
        }
        this.ref = React.createRef();
    }

    componentDidUpdate(oldProps) {
        if (deepEqual(oldProps.data, this.props.data)) return;
        this.setState({
            data: this.props.data
        });
    }

    getData = () => {
        if (this.ref.current) return this.ref.current.getData();
        return this.props.data ?? this.state.data;
    }

    onChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange();
        }
    }

    calculateDisplay = () => {
        if (this.props.allowDynamicDisplay === false) return true;
        if (!!this.props?.meta?.onDisplay) {
            try {
                // eslint-disable-next-line
                const func = new Function(`return (${this.props.meta.onDisplay})`)();
                return func(this.props.data, this.props.parent);
            } catch {
                return false;
            }
        }
        return true;
    }
    
    render() {
        if (!this.calculateDisplay()) return <></>;
        const label = this.props.richTextLabels
            ? <RichTextLabel value={this.props.label} />
            : this.props.label;

        if (this.props.typeName === "DATERANGE") {
            return (<>
                <DateRange ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "LOCATION") {
            return (<>
                <Location ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "ADDRESS") {
            return (<>
                <Address ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "VEHICLE") {
            return (<>
                <Vehicle ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "NAME") {
            return (<>
                <Name ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "TEXT") {
            return (<>
                <Text ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "EMAIL") {
            return (<>
                <Email ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "DATE") {
            return (<>
                <Date ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "NUMERIC") {
            return (<>
                <Numeric ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "CURRENCY") {
            return (<>
                <Currency ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "SELECT") {
            return (<>
                <Select ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "FORMAT") {
            return (<>
                <Format ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "OPTIONTOINPUT") {
            return (<>
                <OptionInput ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "HEADER") {
            return (<>
                <Header meta={this.props.meta} label={label} />
            </>)
        } else if (this.props.typeName === "OPTIONS") {
            return (<>
                <Options ref={this.ref} element={this.props.element} meta={this.props.meta} data={this.props.data} label={label} onChange={this.onChange} />
            </>)
        } else if (this.props.typeName === "COLLECTION") {
            const detailSection = this.props.collectionSections?.find(
                section => String(section.id || section.uuid) === String(this.props.collectionOfUuid)
            );
            return (<>
                <Collection
                    ref={this.ref}
                    element={this.props.element}
                    meta={this.props.meta}
                    data={this.props.data}
                    label={label}
                    detail={this.props.collectionOfUuid}
                    detailSection={detailSection}
                    allowDynamicDisplay={this.props.allowDynamicDisplay}
                    richTextLabels={this.props.richTextLabels}
                    collectionSections={this.props.collectionSections}
                    onChange={this.onChange}
                />
            </>)
        } 
        return <></>;
    }
}

export default QuestionItem;
